import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { loginWithEndUser, endUserOtp } from "../../features/user/userSlice";
import { useState } from "react";
import { AuthContext } from "../../context";
import { useContext } from "react";

const EndUserSignIn = ({ show, onHide }) => {
  const [otpRequested, setOtpRequested] = useState(false);
  const dispatch = useDispatch();
  const { setIsAuthenticated } = useContext(AuthContext); // Use context

  const getSigninSchema = (otpRequested) => {
    return Yup.object().shape({
      email: Yup.string()
        .required("Email is Required")
        .email("Email Should be valid"),
      otp: Yup.string().when("otpRequested", {
        is: otpRequested,
        then: () =>
          Yup.string()
            .required("OTP is Required")
            .matches(/^\d{6}$/, "OTP must be 6 digits"),
        otherwise: () => Yup.string().notRequired(),
      }),
    });
  };

  const handleSubmit = async (values, { resetForm }) => {
    if (!otpRequested) {
      try {
        await dispatch(loginWithEndUser(values.email)).unwrap();
        setOtpRequested(true);
        toast.success("OTP sent to your email.");
      } catch (error) {
        toast.error("Failed to send OTP. Please try again.");
      }
    } else {
      try {
        const response = await dispatch(
          endUserOtp({ email: values.email, otp: values.otp })
        ).unwrap();

        // Only call setIsAuthenticated if it's a function
        if (typeof setIsAuthenticated === "function") {
          setIsAuthenticated(true);
        }
        resetForm();
        onHide();
        toast.success("Sign in successful!");
      } catch (error) {
        toast.error("Invalid OTP. Please try again.");
      }
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Body className="p-4 sm:p-6">
        <div className="relative bg-white rounded-lg">
          <button
            onClick={onHide}
            className="absolute top-2 right-2 bg-transparent border-0"
          >
            <FaTimes size={16} color="#666" />
          </button>
          <div className="text-center mb-4">
            <img
              src="/lifeon.svg"
              alt="Admin"
              className="mx-auto h-16 sm:h-20 mb-2"
            />
            <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-[#00C70D] to-[#005AD0] bg-clip-text text-transparent">
              User Sign In
            </h3>
            <p className="text-gray-500 text-xs sm:text-sm">
              Sign in with your email and OTP
            </p>
          </div>
          <Formik
            initialValues={{
              email: "",
              otp: "",
            }}
            validationSchema={getSigninSchema(otpRequested)}
            onSubmit={handleSubmit}
          >
            {({ values }) => (
              <Form className="flex flex-col gap-4">
                <div>
                  <label className="block text-sm sm:text-base font-semibold">
                    Email
                  </label>
                  <Field
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    className="modern-input w-full mt-1 p-3 text-sm border-gray-300 bg-gray-100 rounded"
                    disabled={otpRequested}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500 text-xs mt-1"
                  />
                </div>
                {otpRequested && (
                  <div>
                    <label className="block text-sm sm:text-base font-semibold">
                      OTP
                    </label>
                    <Field
                      type="text"
                      name="otp"
                      placeholder="Enter 6-digit OTP"
                      className="modern-input w-full mt-1 p-3 text-sm border-gray-300 bg-gray-100 rounded"
                    />
                    <ErrorMessage
                      name="otp"
                      component="div"
                      className="text-red-500 text-xs mt-1"
                    />
                  </div>
                )}
                <button
                  type="submit"
                  className="w-full py-2 bg-gradient-to-r from-[#00C70D] to-[#005AD0] text-white rounded-lg text-sm sm:text-base font-semibold hover:opacity-90 disabled:opacity-50"
                  disabled={!values.email || (otpRequested && !values.otp)}
                >
                  {otpRequested ? "Verify OTP" : "Request OTP"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EndUserSignIn;
